import logo from './logo.svg';
import './App.css';

import "./styles/plugins/index.module.scss";

import {
  Counter,
  NetworkSpeedConverter,
  WeatherApp,
} from "./components";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>

      {/* DEMO */}
      <Counter startingValue={5} />
      <NetworkSpeedConverter />
      <WeatherApp />
    </div>
  );
}

export default App;
